module.exports = __webpack_public_path__ + "static/media/Background.1747a122.png";